//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";

export default class AkConfig extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName(): string {
    return "AkConfig";
  }

  init() {
    this.editor.config.define("ak", {
      kbId: 0,
    });
  }
}
